import React from "react";
import { useTranslation } from "react-i18next";

//MUI Core Components
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

//Material-UI Icons
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import MapIcon from "@mui/icons-material/Map";
import SecurityIcon from "@mui/icons-material/Security";
import SourceIcon from "@mui/icons-material/Source";
import StraightenIcon from "@mui/icons-material/Straighten";

//Custom components

import { DCRecord } from "@/@types/lib/dataController";
import { SxProps } from "@mui/material";
import { TypographyProps } from "@mui/system";

//Types
type FormHeadingExtendedDataProps = {
  record: DCRecord
}

function FormHeadingExtendedData(props: FormHeadingExtendedDataProps) {
  const { t } = useTranslation();

  const { record } = props;

  const { id, podrucje, planina, owner_organisation, data_source, duljina_m, delta_h_m, vrijeme_hhmm } = record;

  const divStyle = {
    display: "flex",
    alignItems: "center", 
    marginLeft: 10
  }

  const iconStyle: SxProps = {
    ml: 1,
    mr: "4px"
  };

  const typographyVariant = "subtitle2"

  const getSource = (data_source_id: number) => {
    switch (data_source_id){
      case 20:
        return t("common.hgss")
      case 30:
        return t("common.hps")
      case 50:
        return t("common.hps-hgss")
      case 61:
        return t("common.via-dinarica")
      case 62:
        return t("common.via-adriatica")
      case 63:
        return t("common.cldt")
      case 70:
        return t("common.tz")
      default:
        return null;
    }
  };

  const getDuljina = (length: number) => {
    if (length > 100) {
      return Math.round((length / 1000) * 100) / 100 + " " + "km";
    } else {
      return Math.round(length * 100) / 100 + " " + "m";
    }
  }

  let lblLocation = [planina, podrucje].filter(x => x).join(", ");

  const owner = owner_organisation === 20 ? t('common.hgss') as string 
    : owner_organisation === 30 ? t('common.hps') as string
    : '';

  const source = data_source ? getSource(data_source as number) : null;

  const duljina = duljina_m ? getDuljina(duljina_m as number) : null;

  return (
    <Stack direction="row">
      <Tooltip title={t("common.id") as string}>
        <div style={divStyle}>
          <FingerprintIcon sx={iconStyle} />
          <Typography align="left" variant={typographyVariant} className="nodrag">
            {id as number}
          </Typography>
        </div>
      </Tooltip>
      {lblLocation ? (
        <Tooltip title={t("common.planina_podrucje") as string}>
          <div style={divStyle}>
            <MapIcon sx={iconStyle} />
            <Typography align="left" variant={typographyVariant} className="nodrag">
              {lblLocation}
            </Typography>
          </div>
        </Tooltip>
      ) : null}
      {owner ? (
        <Tooltip title={t("common.owner_organisation") as string}>
          <div style={divStyle}>
            <SecurityIcon sx={iconStyle} />
            <Typography align="left" variant={typographyVariant} className="nodrag">
              {owner}
            </Typography>
          </div>
        </Tooltip>
      ) : null}
      {source ? (
        <Tooltip title={t("common.data_source") as string}>
          <div style={divStyle}>
            <SourceIcon sx={iconStyle} />
            <Typography align="left" variant={typographyVariant} className="nodrag">
              {source}
            </Typography>
          </div>
        </Tooltip>
      ) : null}
      {/* {duljina ? (
        <Tooltip title={t("staze.duljina") as string}>
          <div style={divStyle}>
            <StraightenIcon sx={iconStyle} />
            <Typography align="left" variant={typographyVariant} className="nodrag">
              {duljina}
            </Typography>
          </div>
        </Tooltip>
      ) : null} */}
    </Stack>
  );
}

export default FormHeadingExtendedData;
